// extracted by mini-css-extract-plugin
export default {"layout":"_0f59032baf _9267b7db55 cfdd65e80e","h_slide":"_09de4db782","category":"_1b4196c467 e87436266a _2ced2c81ae"};